
<script lang='jsx'>
  import {
    AppBar as Header
    ,Button
    ,Icon
    ,Avatar
  } from 'muse-ui'

  import {
    navList
  } from '../router.js'

  export default {
    props: {
      title: String,
      height: {
        type: Number,
        default: 64,
      },
    },
    data () {
      return {
        currNav: 0
      }
    }
    ,render () {
      return (
        <Header class='header'
          title={this.title}
          alt={this.title}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 100,
            height: `${this.height}px`,
          }}
        >
          <template slot='left'>
            <Avatar
              color='#a72028'
              rounded='9'
              style={{ marginLeft: '1em', cursor: 'pointer' }}
            >
              <img
                src='//7dn.naodongenglish.com/logo/logo.outless.png'
                style={{ maxWidth: '95%', maxHeight: '96%' }}
              />
            </Avatar>
          </template>
          <template slot='right'>{
            navList.map((el, il) => {
              return (
                <Button class='btn-nav'
                  flat
                >
                  <small>{el.title}</small>
                </Button>
              )
            })
          }
          </template>
        </Header>
      )
    }
    ,created () {
    }
  }
</script>

<style lang='less' scoped>
@import '../../style/theme.nde.less';

.header{
  .btn-nav{
    margin: auto 1em;
  }
  small{
    color: #333333;
    font-size: 90%;
  }
}
</style>
